module.exports = __webpack_public_path__ + "static/reversal_plan-88dc493411775519fb19de450977648a.png";